import { Component, OnInit } from '@angular/core';
import { TrailsService } from '../../../../../services/trails.service';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
  selector: 'app-trails-management',
  templateUrl: './trails-management.component.html',
  styleUrls: ['./trails-management.component.scss'],
})
export class TrailsManagementComponent implements OnInit {
  public trails: any = [];
  public loading = false;
  public columns: any = [
    { header: 'Trail Name', field: 'trailName', type: 'string' },
    { header: 'Location', field: 'location', type: 'string' },
    { header: 'Country', field: 'country', type: 'string' },
    { header: 'Phone Number', field: 'phoneNumber', type: 'string' },
    { header: 'Status', field: 'trailStatus', type: 'string' },
  ];

  constructor(
    private trailsService: TrailsService,
    private router: Router,
  ) {}

  ngOnInit() {
    this.loading = false;
    this.trailsService.getTrails().subscribe((trails) => {
      this.trails = trails;
      this.loading = false;
    });
  }

  addTrail() {
    this.router.navigateByUrl(
      '/administration/trails-management/trails/create',
    );
  }

  openTrail(UniqueID) {
    this.router.navigateByUrl(
      '/administration/trails-management/trails/' + UniqueID,
    );
  }

  protected readonly HTMLInputElement = HTMLInputElement;
}
